<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size sm_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content"><!-- 200413수정 noline 클래스 삭제 -->
                <dt class="ellipsis">
                    {{ $t('TITLE.MYKNOWLEDGE.BUG.REPORT') }}
                </dt>
                <dd>
                    <div class="opinion_wrap">
                        <p class="q_opinion">{{ $t('MESSAGE.BUGREPORT.OPINION.QUESTION') }}</p>
                        <template v-if="isScmsContents">
                            <ul class="opinion_list">
                                <li data-val="D" :class="(selFlag && selVal === 'D') ? 'active' : ''" @click="optSelect($event)">{{ $t('MESSAGE.BUGREPORT.OPINION.HAVE.QUESTION') }}</li>
                            </ul>  
                        </template>
                        <template v-else>
                            <ul class="opinion_list">
                                <li data-val="A" :class="(selFlag && selVal === 'A') ? 'active' : ''" @click="optSelect($event)">{{ $t('MESSAGE.BUGREPORT.OPINION.MODEL.INACCURATE') }}</li>
                                <li data-val="B" :class="(selFlag && selVal === 'B') ? 'active' : ''" @click="optSelect($event)">{{ $t('MESSAGE.BUGREPORT.OPINION.MORE.INFORMATION') }}</li>
                                <li data-val="C" :class="(selFlag && selVal === 'C') ? 'active' : ''" @click="optSelect($event)">{{ $t('MESSAGE.BUGREPORT.OPINION.MUST.FIXED') }}</li>
                                <li v-show="!isMobile" data-val="D" :class="(selFlag && selVal === 'D') ? 'active' : ''" @click="optSelect($event)">{{ $t('MESSAGE.BUGREPORT.OPINION.HAVE.QUESTION') }}</li>
                            </ul>                            
                        </template>
                        <div class="opinion_textarea align_right">
                            <textarea
                                class="textarea_ty w100p"
                                style="resize: none;"
                                rows="4"
                                maxlength="200"
                                v-model="detailComments"
                                :disabled="optTextFlag"
                                :placeholder="$t('MESSAGE.BUGREPORT.OPINION.PLACEHOLDER')"
                            ></textarea>
                            <span class="textarea_counter">{{ detailComments.length }} / 200</span>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_blue" @click="btnSend">{{ $t('BUTTON.GLOBAL.SEND') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                          from 'vue';
import qs                           from 'query-string';
import axios                        from 'axios';
import _                            from 'lodash';
import { mapGetters, mapActions }   from 'vuex';
import { SDLUtil,  StringUtil }     from '@/utils';
import { EventBus }                 from '@/utils/EventBus';
import createNewQuestionPopup       from '~vb/faq/popup/createNewQuestionPopup';

// get Bug Report Infomation
const fetchFindBugReportFormInfo = knowledgeId => axios.post(
    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionFormBug.skp`,
    qs.stringify({ knowledgeId: knowledgeId }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'BugReportPopup',
    props: {
        knowledgeId:    { required: true },     // 지식에서만 버그 리포트가 쓰인다면 true, 아니라면 false
        isScmsContents: { default: false },     // SCMS 컨텐츠 여부
        rtnFunc:        { type: Function },     // Callback 이벤트, 부모창에서 전달된 이벤트를 가져온다.
    },
    data() {
        return {
            selFlag: false,
            selVal: '',
            optTextFlag: false,
            detailComments: '',

            // Knowledge의 카테고리 코드
            prdCategoryCd1: '',
            prdCategoryCd2: '',
            prdCategoryCd3: '',

            // TODO 용도 확인
            inquiryType1: '',
            inquiryType2: '',

            isMobile: SDLUtil.isMobile(),

            toTitle: '',
            toEmail: '',
            toNm: '',
        }
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
            loginRhq: 'getLoginRhq',
        }),
        // 선택된 값이 있으면 선택된 의견 텍스트를 가져온다.
        getOpinion() {
            if( !SDLUtil.isNull(this.selVal) ) {
                let optList = document.getElementsByClassName('opinion_list')[0].getElementsByTagName('li');
                for(let opt of optList) {
                    if( opt.getAttribute('data-val') === String(this.selVal) ) {
                        return opt.innerText;
                    }
                }

            } else {
                return '';
            }
        }
    },
    methods: {
        async initLoad() {
            await fetchFindBugReportFormInfo(this.knowledgeId).then(res => {
                if(res.data.result.rowCount > 0) {
                    let data = res.data.result.rowData[0];
                    this.prdCategoryCd1 = data['PRD_CATEGORY_CD1'] || '';
                    this.prdCategoryCd2 = data['PRD_CATEGORY_CD2'] || '';
                    this.prdCategoryCd3 = data['PRD_CATEGORY_CD3'] || '';
                    this.toTitle        = data['KNOWLEDGE_TITLE'] || '';
                    this.toNm           = data['TO_NM'] || '';
                    this.toEmail        = data['TO_EMAIL'] || '';
                }
            });
        },
        // 옵션 선택 시 이벤트
        optSelect(e) {
            let v = e.target.getAttribute('data-val');
            this.selFlag = true;
            
            if(v === 'D') {
                this.optTextFlag = true;

            } else {
                this.optTextFlag = false;
            }

            if(this.selVal !== v) this.selVal = v;
        },
        // 전송 이벤트
        async btnSend() {
            let params = {
                KNOWLEDGE_ID: this.knowledgeId,
                REPORT_DESC: this.detailComments || '',
                BUG_TYPE: this.selVal,

                prdCategoryCd1: this.prdCategoryCd1,
                prdCategoryCd2: this.prdCategoryCd2,
                prdCategoryCd3: this.prdCategoryCd3,

                inquiryType1: this.inquiryType1,
                inquiryType2: this.inquiryType2,

                TITLE    : this.toTitle,
                FR_NM    : SDLUtil.getLoginedUserInfo().loginName,
                FR_LEVEL : this.deptLevelCd,
                FR_RHQ   : this.loginRhq,
                TO_NM    : this.toNm,
                TO_EMAIL : this.toEmail,

                /* opinionVal: this.selVal, opinionText: this.getOpinion, */
            };

            // 질문이 있는 경우 New Question popup 실행
            if(this.selVal === 'D') {
                SDLUtil.show(
                    createNewQuestionPopup,
                    params,
                    {
                        width: '500px',
                        height: 'auto',
                    },
                );
                return this.$emit('close');

            } else {
                if(SDLUtil.isNull(this.selVal) || this.selVal === 0) {
                    SDLUtil.alert('MESSAGE.BUGREPORT.OPINION.SELECT');
                    return;
                };

                Vue.$log.info('BugReportPopup.vue send params =>', params);

                SDLUtil.showLoadingBar(true);
                await axios.post( 
                        `${SDLUtil.API_URL}/basis/knowledge/bugReportSave.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                    .then(res => {
                        SDLUtil.showLoadingBar(false);
                        this.btnClose();
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.alert(err);
                    });
            }
        },
        // 닫기 이벤트
        btnClose() {
            this.rtnFunc();
            this.$emit('close');
        }
    },
    created() {
        Vue.$log.info('▶ BugReportPopup.vue created.');
        this.initLoad();
    },
    mounted() {
        //
    },
    beforeDestroy(){
        // Vue.$log.info('▶ BugReportPopup.vue beforeDestroy.');
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/common/popup/BugReportPopup.vue